// Browser Supabase client — anon key only (safe for the browser).
import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.warn('Missing REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY. See env/README.md');
}

// "Remember me": when on (default), the session lives in localStorage and
// survives browser restarts; when off, it lives in sessionStorage and is
// cleared when the browser/tab closes. Call setRemember() before signing in.
const REMEMBER_KEY = 'cysops.remember';
export const setRemember = (v) => localStorage.setItem(REMEMBER_KEY, v ? '1' : '0');
const useLocal = () => localStorage.getItem(REMEMBER_KEY) !== '0'; // default: remember

const rememberStorage = {
  getItem: (k) => sessionStorage.getItem(k) ?? localStorage.getItem(k),
  setItem: (k, v) => {
    if (useLocal()) { localStorage.setItem(k, v); sessionStorage.removeItem(k); }
    else { sessionStorage.setItem(k, v); localStorage.removeItem(k); }
  },
  removeItem: (k) => { localStorage.removeItem(k); sessionStorage.removeItem(k); },
};

export const supabase = createClient(url || 'http://localhost', anonKey || 'public-anon-key', {
  auth: {
    storage: rememberStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
